// extracted by mini-css-extract-plugin
module.exports = {"mochi-checkbox":"mochi-checkbox_mochi-checkbox__zEfbk"};